import React, { memo } from "react"
import styles from './Document.module.css'
import dowanloadSvg from '../../../assets/img/dowanload.svg'
import moment from 'moment'
import 'moment/locale/ru'

const Document = ({ data }) => {
    const formatDate = moment(data.created_at).format('ll')
    return (
        <div className={styles.documentItem}>
            <div className={styles.textContent}>
                <h2 className={styles.title}>
                    {data.name}
                </h2>
                <div>
                    {/* <span style={{ marginRight: '11px', color: '#EF2E25', backgroundColor: '#FFE5E3' }} className="status">{data.mime_type}</span> */}
                    <span className="time">{data.size} {formatDate}</span>
                </div>
            </div>
            <a rel='noreferrer' target={'_blank'} download={data.url} href={data.url}>
                <img alt='Иконка загрузки' src={dowanloadSvg} />
            </a>

        </div>
    )
}
export default memo(Document)